import { APIError, regularErrorCodes } from '@/../../common/src';
import VHKToast from '@/components/VHKToast';

export function VHKUnhandleRejection() {
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason instanceof APIError &&
      !regularErrorCodes.includes(Number(event.reason.code))
    ) {
      VHKToast({
        message: event.reason.message,
      });
      // 阻止默认处理（将错误输出到控制台）
      event.preventDefault();
    } else {
      // 非APIError错误
      console.warn(`UNHANDLED PROMISE REJECTION:`, event.reason);
    }
  });
}
